export function decodeBase64(base64: string) {
	return window.atob(base64 ?? "");
}